import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;

const axios = createAxiosInstance(URL);

export const fetchFlows = (params) => {
    return axios.get('/api/v1/state_machine/flows/', { params });
};

export const fetchStates = (params) => {
    return axios.get('/api/v1/state_machine/states/', { params });
};

export const fetchPreparedOptions = (id, fields, language) => {
    const params = {
        transition_approval_meta: id,
        field__in: fields.join(','),
        language,
    };
    return axios.get('/api/v1/state_machine/prepared_options/', { params });
};
